import { dataService } from '../services/dataService.js';
import { seoService } from '../services/seoService.js';

export async function renderPersonView(personId) {
  const container = document.createElement('div');
  container.className = 'main-content';

  const person = await dataService.getPerson(personId);
  if (!person) {
    container.innerHTML = `<div style="text-align: center; padding: var(--space-2xl) 0;"><p>Artist profile not found.</p><a href="#/" class="btn-primary" style="margin-top: 16px;">Back to Home</a></div>`;
    return container;
  }

  seoService.update({
    title: `${person.name} (${person.role})`,
    description: person.bio,
    image: person.avatar,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Person',
      'name': person.name,
      'alternateName': person.sinhalaName,
      'jobTitle': person.role,
      'description': person.bio
    }
  });

  container.innerHTML = `
    <!-- Artist Profile Header -->
    <div style="display: flex; gap: var(--space-lg); align-items: center; margin-bottom: var(--space-xl); flex-wrap: wrap;">
      <div style="width: 130px; height: 130px; border-radius: var(--radius-full); overflow: hidden; border: 3px solid var(--border-gold); box-shadow: var(--shadow-gold); flex-shrink: 0;">
        <img src="${person.avatar}" alt="${person.name}" style="width: 100%; height: 100%; object-fit: cover;" />
      </div>
      <div style="flex: 1; min-width: 250px;">
        <span class="badge-pill badge-gold" style="margin-bottom: 6px;">${person.role}</span>
        <h1 style="font-size: 1.8rem; font-weight: 800; line-height: 1.2;">${person.name}</h1>
        <div style="font-size: 1.1rem; color: var(--accent-gold); font-weight: 600; margin-bottom: 6px;">${person.sinhalaName || ''}</div>
        <div style="font-size: 0.85rem; color: var(--text-muted);">
          ${person.birthYear ? `Born ${person.birthYear}` : ''} ${person.birthPlace ? `• ${person.birthPlace}` : ''}
        </div>
      </div>
    </div>

    <!-- Biography -->
    <section style="margin-bottom: var(--space-xl);">
      <div class="section-header"><h2 class="section-title">Biography</h2></div>
      <p style="color: var(--text-secondary); line-height: 1.6; font-size: 0.95rem;">${person.bio}</p>
    </section>

    <!-- Known For Section -->
    ${person.knownFor && person.knownFor.length > 0 ? `
      <section style="margin-bottom: var(--space-xl);">
        <div class="section-header"><h2 class="section-title">Known For</h2></div>
        <div style="display: flex; gap: var(--space-md); overflow-x: auto; padding-bottom: 8px;">
          ${person.knownFor.map(k => `
            <a href="#/movie/${k.movieId}" class="song-card clickable-item" style="padding: 10px 14px; min-width: 240px;">
              <img src="${k.poster}" alt="${k.title}" style="width: 48px; height: 68px; object-fit: cover; border-radius: var(--radius-xs);" />
              <div class="song-info">
                <div style="font-size: 0.92rem; font-weight: 700;">${k.title}</div>
                <div style="font-size: 0.78rem; color: var(--accent-gold);">${k.sinhalaTitle || ''}</div>
                <span class="song-artists">${k.year}</span>
              </div>
            </a>
          `).join('')}
        </div>
      </section>
    ` : ''}

    <!-- Chronological Timeline -->
    ${person.timeline && person.timeline.length > 0 ? `
      <section style="margin-bottom: var(--space-xl);">
        <div class="section-header"><h2 class="section-title">Career Milestones & Filmography Timeline</h2></div>
        <div style="position: relative; padding-left: 24px; border-left: 2px solid var(--border-gold); margin-left: 8px;">
          ${person.timeline.map(item => `
            <div style="position: relative; margin-bottom: var(--space-lg);">
              <div style="position: absolute; left: -31px; top: 2px; width: 12px; height: 12px; border-radius: 50%; background: var(--accent-gold); box-shadow: 0 0 10px var(--accent-gold-glow);"></div>
              <div style="font-size: 0.8rem; font-weight: 800; color: var(--accent-gold); text-transform: uppercase;">
                ${item.year}
              </div>
              <div style="font-size: 1.05rem; font-weight: 700; margin: 2px 0;">
                ${item.movieId ? `<a href="#/movie/${item.movieId}" style="color: var(--text-primary); text-decoration: underline dotted;">${item.title}</a>` : item.title}
                <span style="font-size: 0.85rem; color: var(--text-muted); font-weight: normal;">— ${item.role}</span>
              </div>
              <p style="font-size: 0.88rem; color: var(--text-secondary); margin-top: 4px; line-height: 1.4;">
                ${item.highlight}
              </p>
            </div>
          `).join('')}
        </div>
      </section>
    ` : ''}

    <!-- Awards Section -->
    ${person.awards && person.awards.length > 0 ? `
      <section style="margin-bottom: var(--space-xl);">
        <div class="section-header"><h2 class="section-title">Honors & Accolades</h2></div>
        <div style="display: flex; gap: var(--space-xs); flex-wrap: wrap;">
          ${person.awards.map(a => `
            <div class="badge-pill badge-gold" style="padding: 6px 14px;">
              🏆 <strong>${a.ceremony} (${a.year})</strong>: ${a.award}
            </div>
          `).join('')}
        </div>
      </section>
    ` : ''}
  `;

  return container;
}
